import { Component, OnInit } from '@angular/core';

@Component({
   selector: 'samweb-authentication-loading',
   templateUrl: './authentication-loading.component.html',
   styleUrls: ['./authentication-loading.component.scss'],
})
export class AuthenticationLoadingComponent implements OnInit {
   constructor() {}

   ngOnInit() {}
}
